import { useQuery } from "@tanstack/react-query";
import { queryList } from "../../utils";
import { approvalRulesByOrganizationId } from "../../graphql/queries";
import {
  ApprovalRule,
  ApprovalRulesByOrganizationIdQuery,
  ApprovalRulesByOrganizationIdQueryVariables,
} from "../../API";
import { approvalKeys } from "./query-keys";

export const useApprovalRules = (organizationId: string | undefined) =>
  useQuery({
    queryKey: approvalKeys.rules(organizationId),
    queryFn: () =>
      queryList<
        ApprovalRule,
        ApprovalRulesByOrganizationIdQueryVariables,
        ApprovalRulesByOrganizationIdQuery
      >(approvalRulesByOrganizationId, {
        organizationId: organizationId!,
      }),
    enabled: !!organizationId,
  });
